import React from 'react'
import { Dialog, DialogActions, DialogTitle, Button, DialogContent, TextField } from '@material-ui/core'

export default function Confirm(props) {
    const { open, title, onClose, onConfirm, secure , text } = props
    const [isText, setText] = React.useState('')

    return (
        <Dialog
            open={open}
            onClose={() => onClose() }
        >
            <div className="bs-bg">
                <DialogTitle disableTypography><h6 className="text-center fw-bold bs-color-b">{title || 'Tem certeza que deseja excluir ?'}</h6></DialogTitle>
                {secure &&
                <DialogContent>
                    <div className="mb-3">
                        <TextField
                            value={isText || ''}
                            placeholder={text ? text : "excluir"}
                            onChange={e => setText(e.target.value)}
                        />
                    </div>
                </DialogContent>
                }
                <DialogActions className="justify-content-center mb-2">
                    <Button 
                        onClick={() => onClose() }
                        className="bs-color-b"
                    >
                        Não
                    </Button>

                    <Button
                        disabled={secure ? (isText.toLowerCase() === (text ? text : 'excluir') ? false : true) : false}
                        onClick={() => {
                            if(secure) {
                                if(isText.toLowerCase() === (text ? text : 'excluir')) {
                                    onClose()
                                    onConfirm()
                                }
                            }else {
                                onClose()
                                onConfirm()
                            }
                        } }
                        variant="contained"
                        color="primary"
                    >
                        Sim
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    )
}
